import { AvaPicture as Component } from "./AvaPicture";
import Count from "./components/Count/AvaPictureCount";
import Emoji from "./components/Emoji/AvaPictureEmoji";
import Gift from "./components/Gift/AvaPictureGift";
import Icon from "./components/Icon/AvaPictureIcon";
import Image from "./components/Image/AvaPictureImage";
import Initials from "./components/Initials/AvaPictureInitials";
import SlotBottom from "./components/Slots/SlotBottom/AvaPictureSlotBottom";
import SlotBottomLeft from "./components/Slots/SlotBottomLeft/AvaPictureSlotBottomLeft";
import SlotBottomRight from "./components/Slots/SlotBottomRight/AvaPictureSlotBottomRight";
import SlotTopRight from "./components/Slots/SlotTopRight/AvaPictureSlotTopRight";

export interface IAvaPictureExtensions {
    Image: typeof Image;
    Initials: typeof Initials;
    Count: typeof Count;
    Icon: typeof Icon;
    Emoji: typeof Emoji;
    Gift: typeof Gift;
    SlotTopRight: typeof SlotTopRight;
    SlotBottom: typeof SlotBottom;
    SlotBottomRight: typeof SlotBottomRight;
    SlotBottomLeft: typeof SlotBottomLeft;
}

export const AvaPicture: typeof Component & IAvaPictureExtensions =
    Object.assign(Component, {
        Image,
        Initials,
        Count,
        Icon,
        Emoji,
        Gift,
        SlotTopRight,
        SlotBottom,
        SlotBottomRight,
        SlotBottomLeft,
    });

export type {
    AvaPictureProps,
    AvaPictureCountProps,
    AvaPictureEmojiProps,
    AvaPictureIconProps,
    AvaPictureImageProps,
    AvaPictureInitialsProps,
} from "./types";
